import type { SVGProps } from "react";

export function DepartmentStoreIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M12 1.93359C9.51717 1.93359 7.43356 3.94777 7.43356 6.56055V7.43359H6.43161C4.91616 7.43359 3.80923 8.65877 3.69528 10.1699L3.00387 19.332C2.88992 20.8432 4.22476 22.0664 5.7402 22.0664H18.2617C19.7771 22.0664 21.11 20.8432 20.9961 19.332L20.3066 10.1699C20.1927 8.65877 19.0857 7.43359 17.5703 7.43359H16.5664V6.56055C16.5664 3.94777 14.4828 1.93359 12 1.93359ZM12 3.73437C13.6318 3.73437 14.7636 5.11371 14.7636 6.44531C14.7636 6.88923 14.7617 7.2326 14.7616 7.43359H9.24015C9.24005 7.2326 9.23815 6.88923 9.23815 6.44531C9.23815 5.11371 10.3682 3.73437 12 3.73437Z"
        fill="currentColor"
      />
    </svg>
  );
}
